import { Css } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { GuidedChangeEventFormState } from "src/routes/projects/change-events/guided/CreateGuidedChangeEventPage";
import { useSelectConfigurationStepQuery } from "src/routes/projects/change-events/guided/components/2.SelectConfigurationStep.generated";
import { NewConfigurationSection } from "src/routes/projects/change-events/guided/components/NewConfigurationSection";
import { ReadyPlanConfigCard } from "src/routes/projects/change-events/guided/components/ReadyPlanConfigCard";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

type SelectConfigurationStepProps = { formState: GuidedChangeEventFormState };

export function SelectConfigurationStep(props: SelectConfigurationStepProps) {
  const { formState } = props;
  const { projectId } = useRouteParams<ProjectParams>();
  const query = useSelectConfigurationStepQuery({ variables: { structureId: projectId } });
  return queryResult(query, ({ structure }) => (
    <div css={Css.df.fdc.gap4.$}>
      <div>
        <h2 css={Css.xl.$}>Select the Configuration to Apply</h2>
        <p css={Css.sm.gray700.$}>
          Choose an existing Product Offering or Checkout configuration to replace the current configuration on this
          structure.
        </p>
      </div>

      {structure.readyPlanConfig && (
        <div css={Css.df.fdc.gap2.$}>
          <h3 css={Css.lg.$}>Current Configuration</h3>
          <ReadyPlanConfigCard
            structure={structure}
            readyPlanConfig={structure.readyPlanConfig}
            options={structure.readyPlanConfig.readyPlanOptions}
          />
        </div>
      )}

      <NewConfigurationSection formState={formState} structure={structure} />
    </div>
  ));
}
